import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { errMsg } from "../../lib/api";
import { adminApi } from "../../lib/adminApi";

export const StatusBadge = ({ status }) => (
  <span className={`text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-full border ${status === "attivo" ? "border-emerald-500/50 text-emerald-400" : "border-slate-500/50 text-slate-400"}`}>{status}</span>
);

export const AdminPrivateList = ({ onSelect }) => {
  const [list, setList] = useState(null);
  useEffect(() => { adminApi.get("/private-tournaments").then((r) => setList(r.data)).catch((e) => { toast.error(errMsg(e)); setList([]); }); }, []);

  if (!list) return <div className="card-surface h-40 animate-pulse" />;
  return (
    <section className="space-y-3" data-testid="admin-private-list">
      <h2 className="font-display text-2xl font-bold uppercase flex items-center gap-2"><Lock size={20} className="text-amber-400" /> Tornei privati ({list.length})</h2>
      <p className="text-xs text-slate-400">Sola visualizzazione: i giocatori non vedono che li stai guardando.</p>
      {list.length === 0 && <p className="card-surface p-6 text-slate-400">Nessun torneo privato creato dagli utenti.</p>}
      {list.map((t) => (
        <button key={t.id} onClick={() => onSelect(t.id)} data-testid={`admin-private-${t.id}`} className="card-surface w-full text-left p-4 hover:border-amber-500/60 grid grid-cols-2 sm:grid-cols-5 gap-3 items-center">
          <div className="col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-widest text-emerald-400">{t.competition_name}</p>
            <p className="font-display text-xl font-bold uppercase truncate">{t.name}</p>
          </div>
          <p className="text-sm text-slate-300"><span className="text-slate-500 text-xs block">Creatore</span>{t.creator_name}</p>
          <p className="text-sm text-slate-300"><span className="text-slate-500 text-xs block">Giocatori · Giornata</span>{t.members_count} · {t.current_round_label || "—"}</p>
          <div className="sm:text-right"><StatusBadge status={t.status} /></div>
        </button>
      ))}
    </section>
  );
};
